<ng-template #pageTitle>
  <h5 class="text-neutral-900 font-semibold text-2xl ps-2xl">
    {{ 'my_organization_screen_title' | transloco }}
  </h5>
</ng-template>

<div class="h-full flex flex-col" [class]="systemTabsPageClasses()">
  <div class="flex flex-col gap-2xl">
    @if (!floating()) {
      <ng-container [ngTemplateOutlet]="pageTitle" />
    }

    <lib-tabs
      [tabSegmented]="systemTabs()"
      [tabsStartRef]="floating() ? pageTitle : null"
      [tabsHeaderClass]="floating() ? 'mb-lg' : ''"
      [tabPill]="!systemTabs()"
      [tabsBorder]="!systemTabs()"
      [tabsClass]="systemTabs() ? '' : 'border-neutral-200 pb-3xl'"
      (selectTab)="resetSearchAndFilterOnTabChange()"
      [enableTabRouting]="true">
      <lib-tab
        [tabTitle]="'my_organization_screen_first_tab_label' | transloco"
        [showTabTag]="true"
        [tabTag]="insights().in_progress_count"
        [tabRoutingParam]="myOrganizationTabRoutingParam.inProgress"
        #inProgressTab>
        @if (inProgressTab.active()) {
          <lib-in-progress
            (counterRefresh)="getTabsInsight()"
            [totalItems]="insights().in_progress_count" />
        }
      </lib-tab>

      <lib-tab
        [tabTitle]="'step_status_on_hold' | transloco"
        [showTabTag]="true"
        [tabTag]="insights().on_hold_count"
        [tabRoutingParam]="myOrganizationTabRoutingParam.onHold"
        #onHoldTab>
        @if (onHoldTab.active()) {
          <lib-on-hold
            (counterRefresh)="getTabsInsight()"
            [totalItems]="insights().on_hold_count" />
        }
      </lib-tab>

      <lib-tab
        [tabTitle]="'my_organization_screen_second_tab_label' | transloco"
        [showTabTag]="true"
        [tabTag]="insights().closed_count"
        [tabRoutingParam]="myOrganizationTabRoutingParam.closedTasks"
        #closedTaskTab>
        @if (closedTaskTab.active()) {
          <lib-closed-task
            [ClosedRequestFilter]="null"
            [totalItems]="insights().closed_count"
            (counterRefresh)="getTabsInsight()" />
        }
      </lib-tab>
    </lib-tabs>
  </div>
</div>
